import { pubsub, get } from '@assets/js/imaios-global/imaios-global';
import { TREE_VIEW_NOTIFICATIONS } from '@templates/components/structures/treeView/notifications';
import { getHashParameters } from '@imaios-js/utils';

export const TA_FROM_HASH_NAME = 'from';

/**
 * @returns {Promise<string[]>}
 */
export async function getListTaValid() {
  let validTaList = get('valid-ta');
  if (validTaList === undefined || validTaList === null) {
    await pubsub.waitUntil([ { from: pubsub, name: TREE_VIEW_NOTIFICATIONS.LIST_TA_UPDATED } ]);
    validTaList = get('valid-ta');
  }
  return validTaList?.split(',') ?? [];
}

export function getOriginTaFromUrl() {
  const taFromContent = document.getElementById('tree-view-anatomical')?.dataset.treeTaid;
  return getHashParameters(window.location.href).get(TA_FROM_HASH_NAME) ?? taFromContent ?? null
}

export async function selectTerminologyFromLocation(selector) {
  const arrayTAValid = await getListTaValid();
  const from = getOriginTaFromUrl();

  if (
    !arrayTAValid
    || from === null
    || from === ''
    || !arrayTAValid.includes(from)
  ) {
    return;
  }

  document.querySelector(selector)?.click();
}
